import { ResetPassword } from "@/components/ResetPassword";

export const PatientResetPassword = () => {
  return <ResetPassword resetRole="patient" />;
};
